<template>
  <div class="mx-2">
    <p class="font-medium pb-1 w-fit flex cursor-pointer lg:cursor-default text-base uppercase leading-none"
    @click="buttonBrand" @keydown="buttonBrand" @blur="closeBrand">
      {{ $t('frontoffice.products.brand') }}
      <dropdown-arrow />
    </p>
    <ais-refinement-list
      :class-names="{
        // eslint-disable-next-line max-len
        'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
        'ais-RefinementList-searchBox': 'w-full',
        'ais-SearchBox-input': 'placeholder:text-xs',
        // eslint-disable-next-line max-len
        'ais-RefinementList': `${filterBrand} absolute left-4 bg-white dark:bg-slate-700 p-4 rounded-lg lg:p-0 z-50 lg:z-0 border lg:border-none`,
        'ais-RefinementList-noResults': 'dark:text-white'
      }"
      attribute="productBrandName"
      :limit="5"
      :show-more="true"
      :show-more-limit="30"
      :searchable="true"
      :searchable-placeholder="'Search for a brand'"
    />
  </div>
  <div class="mx-2">
    <p class="font-medium pb-1 w-fit flex cursor-pointer lg:cursor-default text-base uppercase leading-none"
    @click="buttonCategory" @keydown="buttonCategory">
      {{ $t('frontoffice.products.category') }}
      <dropdown-arrow />
    </p>
    <ais-refinement-list
      :class-names="{
        // eslint-disable-next-line max-len
        'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
        'ais-RefinementList-searchBox': 'w-full',
        'ais-SearchBox-input': 'placeholder:text-xs',
        // eslint-disable-next-line max-len
        'ais-RefinementList': `${filterCategory} absolute left-4 bg-white dark:bg-slate-700 p-4 rounded-lg lg:p-0 z-50 lg:z-0 border lg:border-none`,
        'ais-RefinementList-noResults': 'dark:text-white'
      }"
      attribute="productCategoryName"
      :limit="5"
      :show-more="true"
      :show-more-limit="30"
      :searchable="true"
      :searchable-placeholder="'Search for a category'"
    />
  </div>
  <div class="mx-2">
    <p class="font-medium pb-1 w-fit flex cursor-pointer lg:cursor-default text-base uppercase leading-none"
    @click="buttonSubcategory" @keydown="buttonSubcategory">
      {{ $t('frontoffice.products.subcategory') }}
      <dropdown-arrow />
    </p>
    <ais-refinement-list
      :class-names="{
        // eslint-disable-next-line max-len
        'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
        'ais-RefinementList-searchBox': 'w-full',
        'ais-SearchBox-input': 'placeholder:text-xs',
        // eslint-disable-next-line max-len
        'ais-RefinementList': `${filterSubcategory} absolute left-4 bg-white dark:bg-slate-700 p-4 rounded-lg lg:p-0 z-50 lg:z-0 border lg:border-none`,
        'ais-RefinementList-noResults': 'dark:text-white'
      }"
      attribute="productSubcategoryName"
      :limit="5"
      :show-more="true"
      :show-more-limit="30"
      :searchable="true"
      :searchable-placeholder="'Search for a subcategory'"
    />
  </div>
  <div class="mx-2">
    <p class="font-medium pb-1 w-fit flex cursor-pointer lg:cursor-default text-base uppercase leading-none"
    @click="buttonAttribute" @keydown="buttonAttribute">
      Autore
      <dropdown-arrow />
    </p>
    <ais-refinement-list
      :class-names="{
        // eslint-disable-next-line max-len
        'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
        'ais-RefinementList-searchBox': 'w-full',
        'ais-SearchBox-input': 'placeholder:text-xs',
        // eslint-disable-next-line max-len
        'ais-RefinementList': `${filterAttribute} absolute left-4 bg-white dark:bg-slate-700 p-4 rounded-lg lg:p-0 z-50 lg:z-0 border lg:border-none`,
        'ais-RefinementList-noResults': 'dark:text-white'
      }"
      attribute="AUTORE"
      :limit="5"
      :show-more="true"
      :show-more-limit="30"
      :searchable="true"
      :searchable-placeholder="'Search for a author'"
    />
  </div>
</template>

<script>
import { AisRefinementList } from 'vue-instantsearch/vue3/es';
import DropdownArrow from '../graphic/DropdownArrow.vue';

export default {
  components: {
    AisRefinementList,
    DropdownArrow,
  },
  data() {
    return {
      showBrand: false,
      showCategory: false,
      showSubcategory: false,
      showAttribute: false,
    };
  },
  computed: {
    filterBrand() {
      return this.showBrand ? 'open' : 'closed';
    },
    filterCategory() {
      return this.showCategory ? 'open' : 'closed';
    },
    filterSubcategory() {
      return this.showSubcategory ? 'open' : 'closed';
    },
    filterAttribute() {
      return this.showAttribute ? 'open' : 'closed';
    },
  },
  methods: {
    buttonBrand() {
      this.showBrand = !this.showBrand;
      this.showCategory = false;
      this.showSubcategory = false;
      this.showAttribute = false;
    },
    buttonCategory() {
      this.showCategory = !this.showCategory;
      this.showBrand = false;
      this.showSubcategory = false;
      this.showAttribute = false;
    },
    buttonSubcategory() {
      this.showSubcategory = !this.showSubcategory;
      this.showBrand = false;
      this.showCategory = false;
      this.showAttribute = false;
    },
    buttonAttribute() {
      this.showAttribute = !this.showAttribute;
      this.showBrand = false;
      this.showCategory = false;
      this.showSubcategory = false;
    },
  },
};
</script>

<style>
.closed {
  display: none;
}

.open {
  display: flex;
  flex-direction: column;
}
</style>
